import { atom } from "recoil"

export const organizationMemberDetailRequestIdState = atom<number>({
  key: "atoms/organization/organizationMemberDetailRequestIdState",
  default: 0,
})
